<template>
  <div class="container-fluid">
    <div class="loading" v-if="isLoading">Loading&hellip;</div>
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Cuenta corriente de proveedores</h1>
          <p class="view-header__subtitle">Saldos y movimientos de las cuentas corrientes con proveedores.</p>
        </div>
      </div>
    </div>

    <!-- STATS -->
    <div class="stats-card">
      <div class="stats-card__value">{{ formatoDinamicoMoneda(displayedBalance) }}</div>
      <div class="stats-card__label">Saldo acumulado de cuentas corrientes</div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-search"></i>
          Buscador
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="doSearch" type="search" class="form-control" placeholder="Buscar...">
          </div>
          <div class="filters-panel__field">
            <div class="form-check">
              <input id="onlymovs" v-model="onlymovs" class="form-check-input" type="checkbox">
              <label class="form-check-label" for="onlymovs">Mostrar sólo proveedores con movimientos</label>
            </div>
          </div>
          <div class="filters-panel__field">
            <div class="form-check">
              <input id="withzero" v-model="withzero" class="form-check-input" type="checkbox">
              <label class="form-check-label" for="withzero">Mostrar proveedores con saldo cero</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
        @viewcc="viewCC"
      />
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import formatDateMixin from "../../../mixins/formatDateMixin";
import formatMoneyMixin from "../../../mixins/formatMoneyMixin";

export default {
  components: {
    VdtnetTable,
  },
  mixins: [formatDateMixin, formatMoneyMixin],
  data: function () {
    return {
      doSearch: '',
      onlymovs: false,
      withzero: false,
      isLoading: false,
      generalBalance: 0,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/providers/accounts",
          data: (d) => {
            d.onlymovs = this.onlymovs;
            d.withzero = this.withzero;
            return d;
          },
          type: 'GET',
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        },
        processing: false,
        pageLength: 15,
        searching: true,
        searchDelay: 100,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        fixedHeader: true,
        autoWidth: false,
      },
      fields: {
        name: {
          label: "Proveedor",
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data}</span>` : data,
        },
        phone_1: { label: "Teléfono", width: "150px" },
        cuit: { label: "CUIT", width: "130px" },
        balance: {
          label: "Saldo actual",
          width: "140px",
          align: "right",
          render: (data, type) => {
            if (type !== 'display') return data;
            const formatted = this.formatoDinamicoMoneda(data);
            const colorClass = data >= 0 ? 'text-success' : 'text-danger';
            return `<span class="data-table__primary ${colorClass}">${formatted}</span>`;
          },
        },
        actions: {
          isLocal: true,
          label: "Detalle",
          width: "110px",
          align: "right",
          defaultContent: `
            <div class="table-action-group">
              <button data-action="viewcc" class="table-action-btn" type="button" title="Ver detalle completo">
                <i class="bi bi-eye"></i>
              </button>
            </div>
          `,
        },
      },
    };
  },
  computed: {
    displayedBalance() {
      return Math.abs(this.generalBalance);
    },
  },
  watch: {
    onlymovs() { this.refreshTable(); },
    withzero() { this.refreshTable(); },
    doSearch(newValue, oldValue) {
      if (newValue.length >= 4 || oldValue.length >= 4) {
        this.$refs.table.search(this.doSearch);
      }
      if (newValue === '' && oldValue.length > 0) {
        this.$refs.table.search(this.doSearch);
      }
    },
  },
  mounted() {
    this.getGeneralBalance();
    this.$nextTick(() => {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      dt.on('preXhr.dt', () => { this.isLoading = true; });
      dt.on('xhr.dt', () => { this.isLoading = false; });
    });
  },
  methods: {
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    viewCC(data) {
      this.$router.push({ name: 'Detalle de cuenta corriente de proveedor', params: { providerId: data.id } });
    },
    getGeneralBalance() {
      this.$http.get("/api/providers/getGeneralBalance").then((response) => {
        this.generalBalance = response.data.data;
      });
    },
  },
};
</script>
